
        import { createApi } from '@reduxjs/toolkit/query/react';
        import { createBaseQuery } from 'src/datahandling/redux/api/apiUtils';

        // Initialize an empty API service that we'll inject endpoints into later as needed
        export const gosApi = createApi({
        reducerPath: 'gosAutoGeneratedApi',
        baseQuery: createBaseQuery("GOS_API"),
        
        endpoints: () => ({}),
        });

        export type gosApiType = typeof gosApi;
        export default gosApi;
    